import React, { useEffect, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import upload from "../../../../../assets/img/upload.png";
import {
  addGeneralDocument,
  deleteImage,
  singleGeneralDocument,
  updateImageIndex,
} from "../../../../../services/AddVehicle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, Collapse, Dialog, Paper, Typography } from "@mui/material";
import { ReactComponent as DropArrow } from "../../../../../assets/icons/down-drop.svg";
import { toast } from "react-toastify";
import { BsInfoCircle } from "react-icons/bs";
import { Button } from "react-bootstrap";

// Helper function to check if the browser supports AVIF
const checkAVIFSupport = () => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.width === 1);
    img.onerror = () => resolve(false);
    img.src = "data:image/avif;base64,AAABAAEAEBAAA..."; // Placeholder for AVIF base64 string.
  });
};

// Function to convert an image to AVIF format (using a library or custom logic)
const convertToAVIF = async (file) => {
  // Here you would implement the logic to convert the image to AVIF format
  // This can be done using libraries or APIs that support AVIF conversion.
  // Returning the same file for now as a placeholder.
  return file;
};

const CarListImage = ({ imageUrl, avifUrl }) => {
  const [useFallback, setUseFallback] = useState(false);
  return (
    <>
      {!useFallback && (
        <source srcSet={avifUrl} type="image/avif" className="img-fluid" />
      )}
      <img
        src={useFallback ? imageUrl : avifUrl}
        className="img-fluid"
        loading="lazy"
        onError={(e) => {
          e.target.onerror = null; // Prevent infinite loop
          setUseFallback(true);
        }}
      />
    </>
  );
};
const DraggableImage = ({
  image,
  section,
  deleteImg,
  id,
  index,
  moveImage,
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: "IMAGE",
    item: { type: "IMAGE", index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "IMAGE",
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverHeight = hoverBoundingRect.bottom - hoverBoundingRect.top;
      const hoverMiddleY = hoverHeight / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      const halfHoverHeight = hoverHeight / 2;

      // Check if the mouse position is within the 50% threshold
      if (
        hoverClientY < hoverMiddleY - halfHoverHeight ||
        hoverClientY > hoverMiddleY + halfHoverHeight
      ) {
        return;
      }

      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }

      // Perform the drop action
      moveImage(dragIndex, hoverIndex);

      // Update the item index
      item.index = hoverIndex;
    },
  });

  const ref = useRef(null);
  drag(drop(ref));

  console.log(image);
  const convertToAvif = (filePath) =>
    filePath ? filePath.replace(/\.[^/.]+$/, ".avif") : "";

  return (
    <div
      ref={ref}
      className={`border rounded dz-preview dz-processing dz-image-preview dz-success dz-complete p-0 mx-auto d-block ${
        isDragging ? "dragging" : ""
      }`}
      style={{ width: "8.25rem" }}
    >
      <div className="">
        {image?.source ? (
          <div className="dz-thumbnail" style={{ width: "7rem" }}>
            <img
              className="img-fluid"
              alt={image?.file?.name}
              src={image?.source}
            />
          </div>
        ) : (
          <div className="dz-thumbnail" style={{ width: "7rem" }}>
            <picture>
              <CarListImage
                avifUrl={`${process.env.REACT_APP_IMG_URL}/${convertToAvif(
                  image?.imagePath
                )}`}
                imageUrl={`${process.env.REACT_APP_IMG_URL}/${image?.imagePath}`}
              />
            </picture>

            {/* <img
              className="img-fluid"
              alt={image?.file?.name}
              src={`${process.env.REACT_APP_IMG_URL}/${image}`}
            /> */}
          </div>
        )}
      </div>
      <div
        onClick={() =>
          deleteImg(id, section, !image?.source && image?.imagePath)
        }
        className="dz-remove cursor-pointer d-flex justify-content-center align-content-center"
      >
        Remove file
      </div>
    </div>
  );
};

const VisualSupport = () => {
  const { id } = useParams();
  const [isDocuments, setDocuments] = useState({});
  const [isRefresh, setRefresh] = useState(false);
  const [uploadedImages, setUploadedImages] = useState({
    Header: [],
    Photoshoot: [],
    Interieur: [],
    Exterieur: [],
  });
  const [hideSection, setHideSection] = useState(true);
  const [avifSupported, setAvifSupported] = useState(false);
  const [showUploading, setShowUploading] = useState(false);
  const [uploadHasError, setUploadHasError] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);

  const fileInputsRef = useRef({
    Header: null,
    Photoshoot: null,
    Interieur: null,
    Exterieur: null,
  });

  const controllerRef = useRef(null);

  useEffect(() => {
    checkAVIFSupport().then((isSupported) => {
      setAvifSupported(isSupported);
    });

    fetchGeneralDocument();
    return () => {
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
    };
  }, [id, isRefresh]);

  const fetchGeneralDocument = async () => {
    const documents = await singleGeneralDocument(id);
    setUploadedImages((prev) => ({
      ...prev,
      Header:
        documents?.data?.[0]?.Header === null
          ? []
          : documents?.data?.[0]?.Header === undefined
          ? []
          : [documents?.data?.[0]?.Header],
      Photoshoot: documents?.data?.[0]?.Photoshoot || [],
      Interieur: documents?.data?.[0]?.["360_interieur"] || [],
      Exterieur: documents?.data?.[0]?.["360_exterieur"] || [],
    }));
    setDocuments(documents?.data);
  };

  const handleImageUpload = async (e, section) => {
    const files = e.target.files;
    const updatedImages = [...uploadedImages[section]];

    Array.from(files).forEach(async (file) => {
      const avifFile = avifSupported ? await convertToAVIF(file) : file;
      updatedImages.push({
        file: avifFile,
        source: URL.createObjectURL(avifFile),
      });
    });

    // setUploadedImages((prevImages) =>
    //   section === "Header"
    //     ? {
    //         ...prevImages,
    //         Header: {
    //           file: files?.[0],
    //           source: URL.createObjectURL(files?.[0]),
    //         },
    //       }
    //     : {
    //         ...prevImages,
    //         [section]: updatedImages,
    //       }
    // );
    const uploadedImageData = { [section]: updatedImages };
    addDocument(uploadedImageData);
  };

  const handleUploadButtonClick = (section) => {
    fileInputsRef.current[section].click();
  };

  const sections = ["Photoshoot", "Interieur", "Exterieur"];

  const addDocument = async (uploadedImageData) => {
    const controller = new AbortController();
    controllerRef.current = controller;
    const signal = controller.signal;
    const formData = new FormData();
    formData.append(
      "Header",
      (uploadedImageData?.Header ?? []).length > 0 &&
        uploadedImageData?.Header[uploadedImageData?.Header.length - 1]?.file
    );

    uploadedImageData?.Photoshoot?.map((item) =>
      formData.append("Photoshoot", item.file)
    );
    uploadedImageData?.Interieur?.map((item) =>
      formData.append("Interieur360", item.file)
    );
    uploadedImageData?.Exterieur?.map((item) =>
      formData.append("Exterieur360", item.file)
    );
    formData.append("general_info", id);
    if (uploadedImageData) {
      setShowUploading(true);
      setUploadHasError("");
      setUploadProgress(0); // Reset progress
      // toast.info("Uploading image, Please wait...");
      await addGeneralDocument(formData, signal, (progress) => {
        const percent = Math.round((progress.loaded * 100) / progress.total);
        setUploadProgress(percent);
      })
        .then((res) => {
          console.log("uploadedImages res", res);
          if (res?.data) {
            setRefresh(true);
            fetchGeneralDocument();

            // toast.success("Image uploaded.");

            setShowUploading(false);
          }
        })
        .catch((err) => {
          // setShowUploading(false);

          setUploadHasError(
            err?.message ||
              "Something went wrong while upload, Please try again."
          );
          console.log("uploadedImages err", err);
        });
    }
  };

  const deleteImg = async (id, key, path) => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      console.log("Download aborted");
    }

    console.log(path);
    setRefresh(false);
    const parts = path ? path?.split("/") : "";
    const filename = parts[parts.length - 1];
    const newKey =
      key === "Interieur"
        ? "360_interieur"
        : key === "Exterieur"
        ? "360_exterieur"
        : key;
    const data = await deleteImage(id, newKey, filename);
    if (data) {
      setRefresh(true);
    }
  };

  const moveImage = async (dragIndex, hoverIndex, section) => {
    console.log(dragIndex, hoverIndex, section);
    const draggedImage = uploadedImages[section][dragIndex];
    const updatedImages = [...uploadedImages[section]];

    updatedImages[dragIndex] = updatedImages[hoverIndex];
    updatedImages[hoverIndex] = draggedImage;
    const data = updatedImages.map((item, index) => ({
      imageId: item?._id,
      newPosition: index,
    }));
    const tempData = {
      general_info: isDocuments?.[0]?.general_info,
      arrayName:
        section === "Interieur"
          ? "360_interieur"
          : section === "Exterieur"
          ? "360_exterieur"
          : section,
      updates: data,
    };

    setUploadedImages((prevImages) => ({
      ...prevImages,
      [section]: updatedImages,
    }));
    const resData = await updateImageIndex(tempData);

    if (resData) {
      await singleGeneralDocument(resData.data.general_info);
    }
  };

  return (
    <Paper sx={{ boxShadow: "0px 4px 18px 0px #4B465C1A", p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          color="#4B465C"
          fontSize={18}
          fontWeight={500}
          role="button"
          onClick={() => setHideSection(!hideSection)}
        >
          Support visuel &nbsp;
          <DropArrow height={18} />
        </Typography>
      </Box>
      <Collapse collapsedSize={0} in={hideSection} timeout="auto" unmountOnExit>
        <Box sx={{ width: "100%", height: "100%", py: 3 }}>
          <div className="row">
            {sections.map((section, index) => (
              <div key={index} className="col-3 mx-auto">
                <h6 className="text-center text-nowrap">
                  {section === "Interieur"
                    ? "360 Interieur"
                    : section === "Exterieur"
                    ? "360 Exterieur"
                    : section}
                </h6>
                <div
                  className="dropzone needsclick dz-clickable"
                  onClick={() => handleUploadButtonClick(section)}
                >
                  <div className="d-flex justify-content-center">
                    <img src={upload} alt="Upload" className="img-fluid" />
                  </div>
                  <input
                    ref={(el) => (fileInputsRef.current[section] = el)}
                    type="file"
                    hidden
                    onChange={(e) => handleImageUpload(e, section)}
                    multiple={section !== "Header"} // Allow multiple file selection for non-Header sections
                  />
                </div>
                <div className="dz-preview-container">
                  {uploadedImages[section]?.map((image, idx) => (
                    <DraggableImage
                      key={idx}
                      image={image}
                      section={section}
                      deleteImg={deleteImg}
                      id={id}
                      index={idx}
                      moveImage={(i1, i2) => moveImage(i1, i2, section)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Box>
      </Collapse>
      <Dialog open={showUploading} maxWidth="sm" fullWidth>
        <Box>
          {!uploadHasError && (
            <div className="p-5">
              <BsInfoCircle fontSize="25px" className="mb-2" />
              <div>
                Uploading in progress please wait, Do not refresh or close the
                window.
              </div>
              {uploadProgress > 0 && uploadProgress < 100 && (
                <div>
                  <progress value={uploadProgress} max="100"></progress>
                  <span>{uploadProgress}%</span>
                </div>
              )}
            </div>
          )}
          {uploadHasError && (
            <div className="p-5">
              {uploadHasError}{" "}
              <div className="mt-2">
                <Button
                  onClick={() => {
                    setShowUploading(false);
                    setUploadHasError("");
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          )}
        </Box>
      </Dialog>
    </Paper>
  );
};

export default VisualSupport;
